import { createAction } from '@ngrx/store';
export namespace ConfigurationActions {
  // Temporary and needs to be deleted after backend's release
  // VIG-18502
  export const useClimateSolutionsDomain = createAction(
    '[CONFIGURATION] Use climate solutions domain'
  );
}
